import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TileFilter from '../../../../Account/Profile/util/TileFilter';
import { TileIterator } from '../../../../Account/Profile/util/tileEnums';
import { getRemindersForAge } from '../../../../Account/Profile/Reminders/util/reminders';
import { getAgeFromBirthDate } from '../../../../../core/util/date';
import { isEmptyArray } from '../../../../../core/util/array';
import { safeGet } from '../../../../../core/util/object';
import { sortFn } from '../../../../Account/Profile/Insurance/util/descriptions/insights';

export default ({ userProfile, category, insuranceDetails }: any) => {
  const accountSummary = useSelector((state: any) => state.account.summary);

  return useMemo(() => {
    const shouldShowTile = (tile: any) =>
      TileFilter.filter(tile, userProfile, {}, accountSummary, insuranceDetails);

    const decoratedTiles = category.tiles.map((tile: any) => ({
      ...tile,
      categoryTitle: category.title,
      categoryId: category.id,
    }));

    let tiles = [];
    switch (category.iterator) {
      case TileIterator.TILES:
        tiles = decoratedTiles;
        break;
      case TileIterator.HEALTH_CHECKLIST: {
        const reminderIds = getRemindersForAge(getAgeFromBirthDate(userProfile.birth_date));
        tiles = decoratedTiles.filter((tile: any) => reminderIds.includes(tile.id));
        break;
      }
      default:
        break;
    }

    const filtered = tiles.filter(shouldShowTile);
    if (filtered.some((t: any) => t.hasOwnProperty('sortOrder'))) {
      let insuranceProfile;
      if (
        accountSummary &&
        !isEmptyArray(accountSummary.insurance_profiles) &&
        userProfile.insurance_profile_id
      ) {
        insuranceProfile = accountSummary.insurance_profiles.find(
          (p: any) => p.insurance_profile_id === userProfile.insurance_profile_id
        );
      }
      const insurerCode = safeGet(insuranceProfile)('insurer_code');
      filtered.sort(sortFn(insurerCode));
    }
    return filtered;
  }, [accountSummary, category, insuranceDetails, userProfile]);
};
